export default {
    SET_SELECT_AGENT(state,Agent){
        state.selectAgent = Agent
    },
    SET_RESULT(state,result){
        state.Result = result
    },
    SET_EDIT_AGENT(state,editAgent){
        state.editAgent = editAgent
    },
}
